<div
  #rolesContainer
  class="u-padding-16 u-card bg-color-white u-position-relative mat-elevation-z1"
>
  <div
    class="u-marginBottom-16"
    fxLayout="row"
    fxLayoutAlign="space-between start"
    fxLayoutGap="16px"
  >
    <div fxFlex="0 1 500px">
      <p
        class="u-marginBottom-8 text-subtitle-2 color-grey"
        i18n="@@hubConfigRoles.title"
      >
        Roles
      </p>
      <p
        class="u-paddingBottom-16 color-grey-300"
        i18n="@@hubConfigRoles.description"
      >
        Create roles that best describe the members in your organization.
      </p>
      @if (group?.is_role_selectable_for_user_introduction_goals ?? true) {
        <div class="u-marginBottom-16">
          <app-chip
            class="u-display-inlineBlock"
            iconPrefix="swap_horizontal_circle"
            i18n="@@hubConfigRoles.userSelectableForMatchingRules"
          >
            Member-level matching rule
          </app-chip>
        </div>
      }
      <div class="u-marginBottom-24" fxLayoutAlign="row" fxLayoutGap="8px">
        <button
          (click)="openEditDrawer()"
          color="primary"
          mat-stroked-button
          i18n="@@hubconfigRoles.addRole"
        >
          Add role
        </button>
        <button
          [matMenuTriggerFor]="segmentMenu"
          color="accent"
          mat-stroked-button
        >
          <span i18n="@@hubconfigRoles.menuCta">Bulk actions</span
          ><i class="material-icons">expand_more</i>
        </button>
        <button
          [disabled]="!enableSort"
          (click)="sortRolesAlphabetically(group, rolesClone)"
          color="primary"
          mat-button
          i18n="@@hubconfigRoles.sortAlphabetically"
        >
          Sort alphabetically
        </button>
      </div>
      <app-best-practices-card
        [body]="bestPractices.body"
        [title]="bestPractices.title"
        class="u-display-block"
      ></app-best-practices-card>
      <div>
        <nz-input-group [nzSuffix]="suffixIconSearch">
          <input
            [formControl]="searchKeywordControl"
            nz-input
            placeholder="Search for roles"
            type="text"
            i18n-placeholder="@@hubConfigRoles.searchPlaceholder"
          />
        </nz-input-group>
        <ng-template #suffixIconSearch>
          <i nz-icon nzType="search"></i>
        </ng-template>
      </div>
      <mat-menu #segmentMenu="matMenu">
        <button
          (click)="openBulkRoleAddDrawer()"
          mat-menu-item
          i18n="@@hubConfigRoles.menuItem.bulkAddRoles"
        >
          Bulk add roles
        </button>
        <button (click)="openBulkRoleDeleteDrawer()" mat-menu-item>
          <span
            class="color-orange"
            i18n="@@hubConfigRoles.menuItem.bulkDeleteRoles"
            >Bulk delete roles</span
          >
        </button>
      </mat-menu>
    </div>
    <button
      (click)="openSettingsDrawer()"
      mat-stroked-button
      type="button"
      i18n="@@global.edit"
    >
      Edit
    </button>
  </div>
  <nz-table
    #rolesTable
    [nzData]="filteredRoles"
    [nzHideOnSinglePage]="true"
    [nzPageSize]="PAGE_SIZE"
    (nzPageIndexChange)="onPageIndexChange($event)"
    nzOuterBordered
  >
    <thead>
      <tr>
        @if (!isDragDropDisabled) {
          <th [ngStyle]="{ padding: 0 }" nzWidth="0"></th>
        }
        <th nzWidth="35%" i18n="@@hubConfigRoles.roleName">Role name</th>
        <th nzWidth="35%">
          <div fxLayout="row" fxLayoutGap="4px">
            <p i18n="@@hubConfigRoles.enabledInteractions">
              Enabled interactions
            </p>
            <mat-icon
              [ngStyle]="{ paddingTop: '2px' }"
              class="color-teal md-16"
              nz-tooltip
              nzTooltipTitle="Members can change these settings in their hub profile"
              i18n-nzTooltipTitle="@@hubConfigRoles.interactionsTooltip"
              >info_outline</mat-icon
            >
          </div>
        </th>
        <th nzWidth="15%" i18n="@@hubConfigRoles.totalMembers">
          Total members
        </th>
        <th nzWidth="15%" i18n="@@hubConfigRoles.actions">Actions</th>
      </tr>
    </thead>
    <tbody
      [cdkDropListEnterPredicate]="dragDropPredicate()"
      (cdkDropListDropped)="rolesOrderChanged($event)"
      cdkDropList
    >
      @for (role of rolesTable.data; track role.name) {
        <tr [cdkDragDisabled]="isDragDropDisabled" cdkDrag>
          @if (!isDragDropDisabled) {
            <td>
              <button
                [ngStyle]="{ opacity: '0.4' }"
                cdkDragHandle
                mat-icon-button
              >
                <mat-icon>drag_indicator</mat-icon>
              </button>
            </td>
          }
          <td>
            <p class="u-wordWrap-breakWord">
              {{ role.name | translationLookup: ['@@groupRole'] }}
            </p>
          </td>
          <td>
            <p>{{ getEnabledInteractions(role) }}</p>
          </td>
          <td>
            <p>{{ roleSegments[role.name] || 0 }}</p>
          </td>
          <td>
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
              <button
                (click)="openEditDrawer(role)"
                aria-label="edit role"
                color="accent"
                mat-icon-button
                i18n-aria-label="@@hubConfigRoles.editRoleAria"
              >
                <mat-icon class="md-18 u-paddingBottom-24">edit</mat-icon>
              </button>
              <mat-divider
                [ngStyle]="{ height: '18px' }"
                vertical
              ></mat-divider>
              <button
                (click)="openDeleteDialog(role)"
                aria-label="delete role"
                mat-icon-button
                i18n-aria-label="@@hubConfigRoles.deleteRoleAria"
              >
                <mat-icon
                  class="md-18 color-grey-300 u-paddingBottom-24"
                  fontSet="material-icons-outlined"
                  >delete</mat-icon
                >
              </button>
            </div>
          </td>
        </tr>
      }
    </tbody>
  </nz-table>
</div>
